export const normal = function (vertices) {
  return [...vertices];
};